<section class="auth-card" aria-labelledby="auth-email-title">
  <form class="auth-form" [formGroup]="form" (ngSubmit)="submit()">
    <h1 class="auth-card__title" id="auth-email-title">
      <ng-container *ngIf="authMode === 'login'; else registerTitle">
        Вход в личный кабинет
      </ng-container>
      <ng-template #registerTitle>
        Регистрация в ПВЗ Админ
      </ng-template>
    </h1>

    <pa-select-button
      [fullWidth]="true"
      formControlName="authMode"
      [options]="authModeOptions"
    />

    <div class="auth-email-actions">
      <div
        class="auth-email-field"
        [class.auth-email-field--error]="!!authErrorMessage()"
      >
        <pa-input
          type="email"
          formControlName="email"
          placeholder="Электронная почта"
          [showClear]="false"
          [customErrorMessages]="emailErrorMessages"
        />
        <p *ngIf="authErrorMessage() as message" class="auth-error" role="alert">
          {{ message }}
        </p>
      </div>

      <label
        *ngIf="authMode === 'register'"
        class="auth-offer"
        for="auth-offer-agree"
      >
        <p-checkbox
          inputId="auth-offer-agree"
          formControlName="agreeOffer"
          [binary]="true"
          size="small"
        />
        <span class="auth-offer__text">
          Согласен с
          <a
            href="https://pvz-admin.ru/oferta.pdf"
            target="_blank"
            rel="noopener noreferrer"
            (click)="onOfferLinkClick($event)"
          >
            условиями публичной оферты
          </a>
        </span>
      </label>

      <pa-button
        [label]="authMode === 'login' ? 'Получить код' : 'Зарегистрироваться'"
        [fullWidth]="true"
        styleClass="auth-submit"
        [disabled]="isSubmitDisabled()"
        (pointerdown)="keyboardHold.hold()"
        (click)="submit()"
      />

      <div *ngIf="authMode === 'register'" class="auth-register-note">
        <pa-message
          severity="info"
          icon="pi pi-info-circle"
          size="small"
        >
          <span style="font-weight: 500;">Сотрудники не регистрируются самостоятельно.</span><br />
          Если вы сотрудник, обратитесь к&nbsp;руководителю, чтобы получить
          доступ к ПВЗ Админ.
        </pa-message>
      </div>
    </div>

    <!--div class="auth-social" aria-label="Войти через сервисы">
      <p class="auth-social__title">Войти через сервисы</p>
      <div class="auth-social__grid" role="group">
        <button type="button" class="auth-social__btn" disabled aria-label="Войти через Яндекс (скоро)" title="Скоро">
          <img class="auth-social__icon" src="/assets/imgs/auth/yandex.svg" alt="" width="24" height="24" />
        </button>
        <button type="button" class="auth-social__btn" disabled aria-label="Войти через Сбер (скоро)" title="Скоро">
          <img class="auth-social__icon" src="/assets/imgs/auth/sber.svg" alt="" width="24" height="24" />
        </button>
        <button type="button" class="auth-social__btn" disabled aria-label="Войти через T ID (скоро)" title="Скоро">
          <img class="auth-social__icon auth-social__icon--t-bank" src="/assets/imgs/auth/t-bank.svg" alt="" width="24" height="13" />
        </button>
        <button type="button" class="auth-social__btn" disabled aria-label="Войти через Госуслуги (скоро)" title="Скоро">
          <img class="auth-social__icon" src="/assets/imgs/auth/gosuslugi.svg" alt="" width="22" height="24" />
        </button>
      </div>
    </div-->

    <app-support-link-v2 />
    <p class="auth-version">ver. {{ environment.appVer }}</p>
  </form>
</section>
